<template functional>
  <div>
    <div
      class="align-info-value"
      v-for="(rate, index) in props.row[props.column]"
      :key="index"
    >
      <p class="mb-0">{{ rate.activity_rate.name }}: &nbsp;</p>
      <format :value="rate.rate_value" :isP="true" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'IncrementRateFormatter',
};
</script>
<style>
.align-info-value {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
